import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {baseFill, baseStroke} from '../shared/partVariants';

interface DashboardBottomProps {
  readonly mode?: PartMode;
  readonly onClick?: () => void;
}

export function DashboardBottom(props: DashboardBottomProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Dashboard Bottom"
      width={55}
      height={348}
      viewBox="0 0 55 348"
      position={{top: 77, left: 469}}
    >
      <path
        d="M15 335C15 340 6 347 1 347L0 347V1H1C6 1 15 8 15 13V115C15 121 15 135 28 137V211C15 213 15 227 15 233V335Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M15 13C15 8 6 1 1 1V80C5.5 80.5 12 84 15 90V13Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M28 211C15 213 15 227 15 233C15 262.242 15 335 15 335C15 340 6 347 1 347V1C6 1 15 8 15 13C15 13 15 85.7581 15 115C15 121 15 135 28 137"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
      <path d="M1 80C5 80 15 86 15 92" stroke="currentColor" className={baseStroke()} />
      <rect x="8" y="41" width="3" height="10" stroke="currentColor" className={baseStroke()} />
      <path
        d="M14 145L14 174L14 203C14 205 14 207.5 18.5 209.21C22.2682 210.642 26 211 26 211C30 211 54 206 54 206L54 174L54 142C54 142 30 137 26 137C26 137 22.2682 137.358 18.5 138.79C14 140.5 14 143 14 145Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <rect
        x="28"
        y="149"
        width="3"
        height="4"
        rx="1.5"
        stroke="currentColor"
        className={baseStroke()}
      />
      <rect
        x="34"
        y="149"
        width="3"
        height="4"
        rx="1.5"
        stroke="currentColor"
        className={baseStroke()}
      />
      <rect
        x="20"
        y="147"
        width="5"
        height="8"
        rx="2.5"
        stroke="currentColor"
        className={baseStroke()}
      />
      <rect
        x="28"
        y="195"
        width="3"
        height="4"
        rx="1.5"
        stroke="currentColor"
        className={baseStroke()}
      />
      <rect
        x="34"
        y="195"
        width="3"
        height="4"
        rx="1.5"
        stroke="currentColor"
        className={baseStroke()}
      />
      <rect
        x="20"
        y="193"
        width="5"
        height="8"
        rx="2.5"
        stroke="currentColor"
        className={baseStroke()}
      />
      <rect
        x="21"
        y="160"
        width="3"
        height="28"
        rx="1.5"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path d="M21 174H24" stroke="currentColor" className={baseStroke()} />
      <path d="M21 167H24" stroke="currentColor" className={baseStroke()} />
      <path d="M21 181H24" stroke="currentColor" className={baseStroke()} />
      <path
        d="M27 162C27 160.895 27.8954 160 29 160L41 160C42.1046 160 43 160.895 43 162V186C43 187.105 42.1046 188 41 188L29 188C27.8954 188 27 187.105 27 186V162Z"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M14 145C19 141.5 26 141 26 141C26 141 51 145 54 146"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M14 203C19 206.5 26 207 26 207C26 207 51 203 54 202"
        stroke="currentColor"
        className={baseStroke()}
      />
      <path
        d="M14 145L14 174L14 203C14 205 14 207.5 18.5 209.21C22.2682 210.642 26 211 26 211C30 211 54 206 54 206L54 174L54 142C54 142 30 137 26 137C26 137 22.2682 137.358 18.5 138.79C14 140.5 14 143 14 145Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
    </PartSvg>
  );
}
